/*
 * File: button-collapse.ts
 * File Created: 2024-03-18 12:41:54
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-24 06:56:34
 * Modified By: Val Liu
 * -----
 */

import { BaseComponent } from "@root/components/base-classes";
import { PropInnateSync } from "@root/core/vue-props/prop-innate-sync";
import { Component } from "vue-property-decorator";

@Component
export default class ButtonCollapse extends BaseComponent {
    @PropInnateSync("value", { type: Boolean, default: false })
    innateValue!: boolean;

    /// private helpers
    toggle() {
        this.innateValue = !this.innateValue;
    }
}
